export const smallArea = {
  legend: 'none',
  chartArea: {
    left: 0,
    bottom: 5,
    width: '100%',
    height: 80
  },
  crosshair: {
    opacity: 0.1
  },
  axisTitlesPosition: 'none',
  vAxis: {
    gridlines: {
      count: 0
    }
  },
  hAxis: {
    gridlines: {
      count: 0
    }
  },
  fontSize: 0,
  enableInteractivity: false,
  tooltip: {
    trigger: 'none'
  }
};
